/**
 * Porte de `Slug.from_title` (catalog/domain/value_objects.py).
 *
 * A decomposição NFKD não é cosmética: sem ela nenhum título em português
 * geraria slug válido ("Produção" → "producao").
 */
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function slugFromTitle(title: string): string {
  return title
    .normalize('NFKD')
    .replace(/[^\p{ASCII}]/gu, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s_-]/g, '')
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
